$(document).ready(function() {
  // Set initial states
  $('.customsec_product .product_container img.hover_img').css('display', 'none');
  $('.customsec_product .product_container img.not_hover').css('display', 'block');

  // Hover in and out logic
  $('.customsec_product .product_container .add-to-cart-button').hover(
    function() { 
      // Mouse enter
      $('img.hover_img').css('display','block');
      $('img.not_hover').css('display','none');
    },
    function() {
      // Mouse leave
      $('img.hover_img').css('display','none');
      $('img.not_hover').css('display','block');
    }
  );
});


document.addEventListener('DOMContentLoaded', () => {
  const timers = document.querySelectorAll('countdown-timer');

  timers.forEach(timer => {
    const year = parseInt(timer.dataset.year);
    const month = parseInt(timer.dataset.month) - 1; // JS months are 0-based
    const day = parseInt(timer.dataset.day);
    const hour = parseInt(timer.dataset.hour);
    const minute = parseInt(timer.dataset.minute);
    const hideAfterExpiry = timer.dataset.hideTimer === "true";
    const completeMessage = timer.dataset.completeMessage || "Offer expired!";

    const targetDate = new Date(year, month, day, hour, minute);

    const daysEl = timer.querySelector('[date-days-placeholder]');
    const hoursEl = timer.querySelector('[date-hours-placeholder]');
    const minutesEl = timer.querySelector('[date-minutes-placeholder]');
    const secondsEl = timer.querySelector('[date-seconds-placeholder]');
    const messageEl = timer.querySelector('[data-message-placeholder]');

    let interval; // declare first so it's available inside updateTimer()

    function updateTimer() {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) {
        if (hideAfterExpiry) {
          timer.style.display = 'none';
        } else if (messageEl) {
          messageEl.textContent = completeMessage;
        }
        clearInterval(interval); // now interval exists
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = days.toString().padStart(2, '0');
      if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
      if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
      if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
    }

    updateTimer(); // run immediately once
    interval = setInterval(updateTimer, 1000); // assign after definition
  });
});


  